import apiHeader from '@/helpers/apiHeader';

const userFormStore = {
    create(params) {
        return apiHeader.post('request-pool/user-form', params);
    }
};
export default userFormStore;